import { APIClient } from '@customerio/hydra-ui-api';
import { getApiBaseUrl } from './base-url';
import { getAuthHeaders } from './auth-headers';
import { recordRumRequest } from '@/services/rum';

/**
 * A typed client for the Pipelines (CDP) backend over a hand-written `paths`
 * type. `timeout` is in milliseconds; 0 turns the client's 30 s default off,
 * which callers whose requests can outlast it (a warehouse query) need.
 */
export function createCdpApiClient<Paths>({ timeout }: { timeout?: number } = {}) {
  return new APIClient<Paths>({
    // The Pipelines backend is reached under `/cdp/api` on the regional Journeys
    // host, so prefix the region/env base URL (resolved per request) — matching
    // the previous ts-rest client, which routed through `getApiBaseUrl()`.
    baseUrl: () => `${getApiBaseUrl()}/cdp/api`,
    fetchOptions: { credentials: 'include' },
    headers: getAuthHeaders,
    onRequestTiming: recordRumRequest,
    timeout,
  });
}
